import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type BranchFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const BranchFilled = forwardRef<SVGSVGElement, BranchFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-2.100003 -2.100677) scale(1.566667)">
        <path d="M15.1957 11.6419V9.16347C15.1954 8.94733 15.1094 8.74012 14.9566 8.58729C14.8038 8.43446 14.5966 8.34849 14.3804 8.34825H9.32609V6.35892C10.0694 6.20749 10.6304 5.54869 10.6304 4.76129C10.6304 3.86231 9.89898 3.13086 9 3.13086C8.10102 3.13086 7.36957 3.86231 7.36957 4.76129C7.36957 5.54869 7.93064 6.20749 8.67391 6.35892V8.34825H3.61957C3.40343 8.34849 3.19622 8.43446 3.04339 8.58729C2.89056 8.74012 2.80459 8.94733 2.80435 9.16347V11.6419C2.06107 11.7934 1.5 12.4522 1.5 13.2396C1.5 14.1385 2.23145 14.87 3.13043 14.87C4.02942 14.87 4.76087 14.1385 4.76087 13.2396C4.76087 12.4522 4.1998 11.7934 3.45652 11.6419V9.16347C3.45652 9.12023 3.4737 9.07876 3.50428 9.04818C3.53485 9.0176 3.57632 9.00043 3.61957 9.00043H8.67391V11.6419C7.93064 11.7934 7.36957 12.4522 7.36957 13.2396C7.36957 14.1385 8.10102 14.87 9 14.87C9.89898 14.87 10.6304 14.1385 10.6304 13.2396C10.6304 12.4522 10.0694 11.7934 9.32609 11.6419V9.00043H14.3804C14.4237 9.00043 14.4651 9.0176 14.4957 9.04818C14.5263 9.07876 14.5435 9.12023 14.5435 9.16347V11.6419C13.8002 11.7934 13.2391 12.4522 13.2391 13.2396C13.2391 14.1385 13.9706 14.87 14.8696 14.87C15.7685 14.87 16.5 14.1385 16.5 13.2396C16.5 12.4522 15.9389 11.7934 15.1957 11.6419Z" />
      </g>
    </svg>
  ),
);

BranchFilled.displayName = 'BranchFilled';

export default BranchFilled;
